<template>
    <b-modal
        title="Add Vehicle"
        v-model="modalVisible"
        ok-title="Create Vehicle"
    >
        <b-form role="form">
            <b-form-group id="name-group" label="Name*" label-for="input-name">
                <b-form-input
                    type="text"
                    id="input-name"
                    v-model="model.name"
                    required
                    placeholder="Enter Name"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="registration-group"
                label="Registration*"
                label-for="input-registration"
            >
                <b-form-input
                    type="text"
                    id="input-registration"
                    v-model="model.registration"
                    required
                    placeholder="Enter Registration"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="model-group"
                label="Model*"
                label-for="input-model"
            >
                <b-form-input
                    type="text"
                    id="input-model"
                    v-model="model.model"
                    required
                    placeholder="Enter Model"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="description-group"
                label="Description"
                label-for="input-description"
            >
                <b-form-textarea
                    id="input-description"
                    v-model="model.description"
                    placeholder="Enter Description"
                    rows="3"
                ></b-form-textarea>
            </b-form-group>

            <b-form-group
                id="color-group"
                label="Color"
                label-for="input-color"
            >
                <b-form-input
                    type="color"
                    id="input-color"
                    v-model="model.color"
                    placeholder="Enter Color"
                ></b-form-input>
            </b-form-group>
        </b-form>
        <template #modal-footer="{ cancel }">
            <b-button-group size="sm">
                <b-button variant="primary" @click="create"> Create </b-button>
                <b-button variant="warning" @click="cancel()">
                    Cancel
                </b-button>
            </b-button-group>
        </template>
    </b-modal>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

const model = {
    name: '',
    registration: '',
    make: '',
    model: '',
    description: '',
    color: '#efefef',
    active: '',
}
export default {
    name: 'fleet-createForm',
    mixins: [permissionsMixins],
    props: [],

    data: () => {
        return {
            modalVisible: false,
            model: {
                ...model,
            },
            submitting: false,
            hasErrors: false,
        }
    },
    methods: {
        showModal() {
            this.model = { ...model }
            this.modalVisible = true
        },
        hideModal() {
            this.modalVisible = false
        },

        create() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.submitting = true
                    this.$store
                        .dispatch('fleet/create', this.model)
                        .then(() => {
                            this.model = {
                                name: '',
                                registration: '',
                                make: '',
                                model: '',
                                description: '',
                                color: '#efefef',
                                active: '',
                            }
                            this.submitting = false
                            this.$emit('success')
                        })
                        .catch(error => {
                            this.$emit("error",error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },
    },
}
</script>
